import { getContext as getFiverrContext } from '@fiverr-private/fiverr_context';
import { PLATFORMS } from '../../../constants';
import { MONICORE_SPANS } from './constants';

/**
 * Get the current monicore request based on fiverr_context
 * @returns {object}
 */
export const getContext = () => {
    const { pageCtxId, userId, countryCode, locale, isMobile, currency } = getFiverrContext();

    return {
        id: pageCtxId || '',
        userId: userId || '',
        countryCode: countryCode || '',
        locale: locale || '',
        currency: currency || '',
        platform: isMobile ? PLATFORMS.MOBILE_WEB : PLATFORMS.WEB,
    };
};

/**
 * Store the span start in current window
 * @param {string} name - The name of the span
 * * @param {number} startedAt - The epoch ms timestamp of the span start
 */
export const storeStartedSpan = (name, startedAt) => {
    if (!window[MONICORE_SPANS]) {
        window[MONICORE_SPANS] = {};
    }

    window[MONICORE_SPANS][name] = startedAt;
};

/**
 * Get the previous started span, if available
 * @param {string} name - The name of the span
 * @returns {number}
 */
export const getSpanStart = (name) => {
    if (window[MONICORE_SPANS]) {
        return window[MONICORE_SPANS][name];
    }
};

/**
 * Check if the events of the current context are included in the configured sampling percentage
 *
 * For now, the sampling logic is on server only, browser always returns true
 *
 * @returns {boolean}
 */
export const isInSamplingPercentage = () => true;
